import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AppStore } from 'app/store/app.store';

export const antiGuard: CanActivateFn = (): true | UrlTree => {
  const router = inject(Router);
  const store = inject(AppStore);

  return !store.isUserAuthenticated() ? true : router.createUrlTree(['/']);
};
